export const FETCH_SYSTEM_SETTINGS = "FETCH_SYSTEM_SETTINGS"
export const FETCH_SYSTEM_LOCATIONS = "FETCH_SYSTEM_LOCATIONS"
export const UPDATE_SYSTEM_SETTINGS = "UPDATE_SYSTEM_SETTINGS"